<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('商家名称')" prop="merchantName">
                <a-input v-model="queryParam.merchantName" :maxLength="32" :placeholder="$t('请输入')+$t('商家名称')" @pressEnter="handleQuery" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('商家类型')" prop="merchantType">
                <a-select :placeholder="$t('请选择')+$t('商家类型')" v-model="queryParam.merchantType" style="width: 100%" allow-clear>
                  <a-select-option v-for="(d, index) in this.customDict.MerchantTypeEnum" :key="index" :value="d.type">{{ d.name }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('状态')" prop="merchantType">
                <a-select :placeholder="$t('请选择')+$t('状态')" v-model="queryParam.merchantApplyStatus" style="width: 100%" allow-clear>
                  <a-select-option v-for="(d, index) in this.customDict.MerchantApplyStatusEnum" :key="index" :value="d.type">{{ d.name }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
              <a-col :md="6" :sm="24">
                <a-form-item :label="$t('主营行业')" prop="industryId">
                  <a-select v-model="queryParam.industryId" :placeholder="$t('请选择')+$t('主营行业')" >
                    <a-select-option v-for="(item, index) in industryList" :value="item.id" :key="index">
                      {{ item.categoryName }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24">
                <a-form-item :label="$t('联系人姓名')" prop="contactName">
                  <a-input v-model="queryParam.contactName" :maxLength="32" :placeholder="$t('请输入')+$t('联系人姓名')" @pressEnter="handleQuery" allow-clear/>
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24">
                <a-form-item :label="$t('联系人电话')" prop="contactPhone">
                  <a-input v-model="queryParam.contactPhone" :maxLength="32" :placeholder="$t('请输入')+$t('联系人电话')" @pressEnter="handleQuery" allow-clear/>
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24">
                <a-form-item :label="$t('联系人邮箱')" prop="contactEmail">
                  <a-input v-model="queryParam.contactEmail" :maxLength="32" :placeholder="$t('请输入')+$t('联系人邮箱')" @pressEnter="handleQuery" allow-clear/>
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24">
                <a-form-item :label="$t('身份证号')" prop="contactCardNo">
                  <a-input v-model="queryParam.contactCardNo" :maxLength="32" :placeholder="$t('请输入')+$t('身份证号')" @pressEnter="handleQuery" allow-clear/>
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24">
                <a-form-item :label="$t('创建开始时间')" prop="createBeginTime">
                  <a-date-picker style="width: 100%" v-model="queryParam.createBeginTime"
                     :show-time="{defaultValue: moment('00:00:00', 'HH:mm:ss')}"
                     valueFormat="YYYY-MM-DD HH:mm:ss" allow-clear/>
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24">
                <a-form-item :label="$t('创建结束时间')" prop="createEndTime">
                  <a-date-picker style="width: 100%" v-model="queryParam.createEndTime"
                     :show-time="{defaultValue: moment('23:59:59', 'HH:mm:ss')}"
                     valueFormat="YYYY-MM-DD HH:mm:ss" allow-clear/>
                </a-form-item>
              </a-col>
            <a-col :md="!advanced && 6 || 24" :sm="24">
              <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />{{$t('查询')}}</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />{{$t('重置')}}</a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
        <a-modal :visible="previewImageVisible" :footer="null" @cancel="previewImageCancel">
          <img alt="example" style="width: 100%" :src="previewUrl" />
        </a-modal>
      </div>
      <!-- 操作 -->
      <div class="table-operations">
        <a-button type="primary" :disabled="single" @click="$refs.createForm.handleUpdate(undefined, ids)" v-hasPermi="['merchant:merchantapply:edit']">
          <a-icon type="edit" />{{$t('修改')}}
        </a-button>
        <a-button type="primary" @click="handleExport" v-hasPermi="['merchant:merchantapply:export']">
          <a-icon type="download" />{{$t('导出')}}
        </a-button>
        <table-setting
          :style="{float: 'right'}"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList" />
      </div>
      <!-- 增加修改 -->
      <create-form
        ref="createForm"
        @ok="getList"
      />
      <audit-form
        ref="auditForm"
        @ok="getList"
      />
      <!-- 数据展示 -->
      <a-table
        v-table-sticky="{ fixedTop: 64 }"
        :scroll="{ x: 1200 }"
        :loading="loading"
        :size="tableSize"
        @change="handleSortChange"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :pagination="false"
        :bordered="tableBordered"
      >
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>
        <template slot="merchantLogo" slot-scope="text, record">
          <div>
            <img v-if="record.merchantLogo" :src="record.merchantLogo" style="width:50px;height:50px;" @click="handleRecordPreview(record.merchantLogo)" alt="none"/>
          </div>
        </template>
        <span slot="businessType" slot-scope="text, record">
          <custom-dict-tag :options="customDict.BusinessTypeEnum" :value="record.businessType"/>
        </span>
        <span slot="merchantApplyStatus" slot-scope="text, record">
          <custom-dict-tag :options="customDict.MerchantApplyStatusEnum" :value="record.merchantApplyStatus"/>
        </span>
        <span slot="merchantType" slot-scope="text, record">
          <custom-dict-tag :options="customDict.MerchantTypeEnum" :value="record.merchantType"/>
        </span>
        <span slot="operation" slot-scope="text, record">
          <a-divider type="vertical" v-hasPermi="['merchant:merchantapply:edit']" />
          <a @click="$refs.createForm.handleUpdate(record, undefined)" v-hasPermi="['merchant:merchantapply:edit']">
             <a-icon type="edit" />{{$t('修改')}}
          </a>
          <a-divider type="vertical" v-hasPermi="['merchant:merchantapply:audit']" v-if="record.merchantApplyStatus === 11 || record.merchantApplyStatus === 13"/>
          <a @click="$refs.auditForm.handleAudit(record.id, 'merchant')" v-hasPermi="['merchant:merchantapply:audit']" v-if="record.merchantApplyStatus === 11 || record.merchantApplyStatus === 13">
             <a-icon type="edit" />{{$t('审核')}}
          </a>
          <a-divider type="vertical" v-hasPermi="['merchant:merchantapply:marginaudit']" v-if="record.merchantApplyStatus === 21 || record.merchantApplyStatus === 23 " />
          <a @click="$refs.auditForm.handleAudit(record.id, 'margin')" v-hasPermi="['merchant:merchantapply:marginaudit']" v-if="record.merchantApplyStatus === 21 || record.merchantApplyStatus === 23">
             <a-icon type="edit" />{{$t('保证金审核')}}
          </a>
          <a-divider type="vertical" v-hasPermi="['merchant:merchantapply:marginaudit']" v-if="record.merchantApplyStatus === 31 " />
          <a @click="$refs.auditForm.handleAudit(record.id, 'renewal')" v-hasPermi="['merchant:merchantapply:marginaudit']" v-if="record.merchantApplyStatus === 31">
             <a-icon type="edit" />{{$t('续费审核')}}
          </a>
<!--          <a-divider type="vertical" v-hasPermi="['merchant:merchantapply:remove']" v-if="record.merchantApplyStatus !== 22" />
          <a @click="handleDelete(record)" v-hasPermi="['merchant:merchantapply:remove']" v-if="record.merchantApplyStatus !== 22">
            <a-icon type="delete" />{{$t('删除')}}
          </a>-->
        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :pageSizeOptions="pageSizeOptions"
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="total => getTotal(total)"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { pageMerchantApply,listMerchantApply, delMerchantApply } from '@/api/merchant/merchantApply'
import { listIndustry } from '@/api/merchant/industry'
import CustomDictTag from "@/components/DictCustomTag";
import {mapGetters} from 'vuex'
import moment from 'moment';
import CreateForm from './modules/CreateForm'
import AuditForm from './modules/AuditForm.vue'
import { tableMixin } from '@/store/table-mixin'

export default {
  name: 'MerchantApply',
  components: {
    CustomDictTag,
    AuditForm,
    CreateForm
  },
  mixins: [tableMixin],
  data () {
    return {
      list: [],
      pageSizeOptions: ['10', '20', '50', '100'],
      filteredInfo: {},
      sortedInfo : {},
      industryList:[],
      industrySelected:[],
      selectedRowKeys: [],
      selectedRows: [],
      //预览封面
      previewImageVisible: false,
      previewUrl: false,
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      // 查询参数
      queryParam: {
        merchantId: undefined,
        merchantName: undefined,
        merchantLogo: undefined,
        merchantBackground: undefined,
        merchantAreax: undefined,
        merchantAddress: undefined,
        merchantApplyStatus: undefined,
        merchantDescription: undefined,
        merchantType: undefined,
        longitude: undefined,
        latitude: undefined,
        marginAmount: undefined,
        industryId: undefined,
        timeOfEntry: undefined,
        customerServiceMobile: undefined,
        businessType: undefined,
        companyAreax: undefined,
        companyName: undefined,
        companyAddress: undefined,
        businessLicenceNo: undefined,
        businessLicenseImg: undefined,
        contactName: undefined,
        contactPhone: undefined,
        contactEmail: undefined,
        contactCardNo: undefined,
        contactCardImg: undefined,
        contactCardNational: undefined,
        contactCardFace: undefined,
        accountType: undefined,
        accountBankCode: undefined,
        accountBankName: undefined,
        accountBankAreaId: undefined,
        accountBankBranchCode: undefined,
        accountImg: undefined,
        accountNo: undefined,
        accountName: undefined,
        imgDetail: undefined,
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        {
          title: this.$t('商家名称'),
          dataIndex: 'merchantName',
          align: 'center'
        },
        {
          title: this.$t('商家logo'),
          dataIndex: 'merchantLogo',
          scopedSlots: { customRender: 'merchantLogo' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('商家所在地'),
          dataIndex: 'merchantAreaxName',
          align: 'center'
        },
        {
          title: this.$t('商家状态'),
          dataIndex: 'merchantApplyStatus',
          scopedSlots: { customRender: 'merchantApplyStatus' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('商家类型'),
          dataIndex: 'merchantType',
          scopedSlots: { customRender: 'merchantType' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('主营行业'),
          dataIndex: 'industryName',
          align: 'center'
        },
        {
          title: this.$t('入驻时长'),
          dataIndex: 'timeOfEntryName',
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('开店套餐'),
          dataIndex: 'merchantLevelName',
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('联系人姓名'),
          dataIndex: 'contactName',
          align: 'center'
        },
        {
          title: this.$t('联系人电话'),
          dataIndex: 'contactPhone',
          align: 'center'
        },
        /*{
          title: this.$t('联系人邮箱'),
          dataIndex: 'contactEmail',
          ellipsis: true,
          align: 'center'
        },*/
        {
          title: this.$t('身份证号'),
          dataIndex: 'contactCardNo',
          align: 'center'
        },
        {
          title: this.$t('创建时间'),
          dataIndex: 'createTime',
          scopedSlots: { customRender: 'createTime' },
          align: 'center'
        },
        {
          title: this.$t('操作'),
          dataIndex: 'operation',
          width: '12%',
          scopedSlots: { customRender: 'operation' },
          align: 'center'
        }
      ]
    }
  },
  filters: {
  },
  created () {
    this.getIndustryList()
    this.getList()
  },
  computed: {
    ...mapGetters(['customDict'])
  },
  watch: {
  },
  methods: {
    moment,
    getTotal(total) {
      return this.$t('共')+total+this.$t('条')
    },
    /** 查询商家申请列表 */
    getList () {
      this.loading = true
     pageMerchantApply(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },
    onIndustryChange(value, selectedOptions) {
      this.queryParam.industryId = value[1]
      console.log('onIndustryChange',this.queryParam.industryId)

    },
    getIndustryList() {
      listIndustry({}).then(response => {
        this.industryList = response.data
      })
    },
    /** 搜索按钮操作 */
    handleQuery () {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.queryParam = {
        merchantId: undefined,
        merchantName: undefined,
        merchantLogo: undefined,
        merchantBackground: undefined,
        merchantAreax: undefined,
        merchantAddress: undefined,
        merchantApplyStatus: undefined,
        merchantDescription: undefined,
        merchantType: undefined,
        longitude: undefined,
        latitude: undefined,
        marginAmount: undefined,
        industryId: undefined,
        timeOfEntry: undefined,
        customerServiceMobile: undefined,
        businessType: undefined,
        companyAreax: undefined,
        companyName: undefined,
        companyAddress: undefined,
        businessLicenceNo: undefined,
        businessLicenseImg: undefined,
        contactName: undefined,
        contactPhone: undefined,
        contactEmail: undefined,
        contactCardNo: undefined,
        contactCardImg: undefined,
        contactCardNational: undefined,
        contactCardFace: undefined,
        accountType: undefined,
        accountBankCode: undefined,
        accountBankName: undefined,
        accountBankAreaId: undefined,
        accountBankBranchCode: undefined,
        accountImg: undefined,
        accountNo: undefined,
        accountName: undefined,
        imgDetail: undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.industrySelected = []
      this.handleQuery()
    },
    handleSortChange(pagination, filters, sorter) {
      this.filteredInfo = filters
      this.sortedInfo = sorter
      if (sorter.order) {
        /** 排序字段 sortField **/
        /** 排序方式  sortOrder**/
        this.queryParam.sortField = sorter.columnKey
        if (this.queryParam.sortField==='createTime') {
          this.queryParam.sortField= 'id'
        }
        this.queryParam.sortOrder = sorter.order === 'ascend' ? 'asc' : 'desc'
        this.getList()
      } else {
        this.queryParam.sortField = '';
        this.queryParam.sortOrder = ''
        this.getList()
      }
    },
    onShowSizeChange (current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    previewImageCancel() {
      this.previewImageVisible = false;
    },
    handleRecordPreview(url) {
      this.previewUrl = url
      this.previewImageVisible = true
    },
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    /** 删除按钮操作 */
    handleDelete (row) {
      var that = this
      const ids = row.id || this.ids
      if(row.id){
        this.ids = []
        this.ids.push(row.id)
      }
      this.$confirm({
        title: this.$t('确认删除所选中数据'),
        onOk () {
          let data = []
          that.ids.map(id => data.push({"id":id}))
          return delMerchantApply(data)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              const message = that.$t('删除成功')
              that.$message.success(
                message,
                3
              )
          })
        },
        onCancel () {
          //取消清空删除ids列表
          that.ids = []
        }
      })
    },
    /** 导出按钮操作 */
    handleExport () {
      var that = this
      this.$confirm({
        title: this.$t('是否确认导出'),
        content: this.$t('此操作将导出当前条件下所有数据而非选中数据'),
        onOk () {
          that.download('biz/admin/merchant/apply/export',
            that.queryParam
          , `商家申请_${new Date().getTime()}.xlsx`)
        },
        onCancel () {}
      })
    }
  }
}
</script>
